import type { JSX } from 'react'
import type { ILabelInlinePrimaryTemplateProps } from 'atoms/Label/Templates'
import type { IProgressBarAccentTemplate } from 'atoms/ProgressBar/Templates'
import type { ITVShowPopupProps } from 'blocks/Popup/Templates'
import type { ITextBlockDescriptionType1 } from 'blocks/TextBlock/Templates'
import type { ICard } from '../Card'

import { InlinePlaySolidButton } from 'atoms/Button/Templates'
import { LabelInlinePrimaryTemplate } from 'atoms/Label/Templates'
import { ProgressBarAccentTemplate } from 'atoms/ProgressBar/Templates'
import { TextBlockHorizontalType1 } from 'blocks/TextBlock/Templates'
import { CARDS_ASPECT_RATIO, CardAnimations } from '../Card.h'
import {
  CardContent,
  CardInnerStyled,
  CardStyled,
  CardStyledContent,
} from './TVShowEpisodeCard.styled'

export interface ITVShowEpisodeAnimatedCardProps extends Omit<
  ICard,
  'children'
> {
  progress?: IProgressBarAccentTemplate['progress']
  labelTitle?: ILabelInlinePrimaryTemplateProps['title']
  title?: ITextBlockDescriptionType1['title']
  description?: ITextBlockDescriptionType1['description']
  children?: JSX.Element[]
  viewedButtonWithHover?: boolean
  titlePopup?: ITVShowPopupProps['title']
  descriptionPopup?: ITVShowPopupProps['description']
  labelsPopup?: ITVShowPopupProps['labels']
  listPopup?: ITVShowPopupProps['list']
  viewedButtonInfo?: boolean
}

export const TVShowEpisodeAnimatedCard = ({
  posterUrl = '',
  aspectRatio: _unused1 = CARDS_ASPECT_RATIO.HORIZONTAL_TV_SHOW_OUTER_CARD,
  width = '100%',
  labelTitle = '',
  title = '',
  description = '',
  progress = 0,
  children,
  viewedButtonWithHover = true,
  viewedButtonInfo = false,
  titlePopup: _unused2,
  descriptionPopup: _unused3,
  labelsPopup: _unused4,
  listPopup: _unused5,
  ...rest
}: ITVShowEpisodeAnimatedCardProps): JSX.Element => (
  <CardStyled width={width} {...rest}>
    <CardStyledContent
      viewedButtonInfo={viewedButtonInfo}
      viewedButtonWithHover={viewedButtonWithHover}
    >
      <CardInnerStyled
        posterUrl={posterUrl}
        width={width}
        aspectRatio={CARDS_ASPECT_RATIO.HORIZONTAL_TV_SHOW_INNER_CARD}
        overlayEnabled={true}
        transitionName={CardAnimations.ScaleUp110}
      >
        {children?.[0] || (
          <CardContent>
            {viewedButtonWithHover && <InlinePlaySolidButton />}
            <LabelInlinePrimaryTemplate title={labelTitle} />
            <ProgressBarAccentTemplate progress={progress} />
          </CardContent>
        )}
      </CardInnerStyled>
      {children?.[1] || (
        <TextBlockHorizontalType1 title={title} description={description} />
      )}
    </CardStyledContent>
  </CardStyled>
)
